export const LICENSES_MODULE_VIEWS = {
    LICENSE_ASSIGN: "LICENSE ASSIGN",
    LICENSE_ASSIGN_BULK: "LICENSE ASSIGN BULK",
};